import { TableRow, TableCell, Box } from "@mui/material";
import { useState } from "react";
import { ColorPallet } from "../../utils/colorPallet";
import AddNewShelfModal from "./addNewShelfModal";
import ViewShelfBranchDetails from "./viewShelfBranchDetails";

interface BatchData {
  id: number;
  Batch: string;
  MedicineName: string;
  RemainingQty: string;
  ProductionDate: string;
  SupplierName: string;
}

const commonTableCellStyles = {
  borderTop: `1px solid ${ColorPallet.borderColor}`,
  borderRight: `1px solid ${ColorPallet.borderColor}`,
  borderBottom: `1px solid ${ColorPallet.borderColor}`,
  "&.MuiTableCell-root": {
    padding: "5px 0px 5px 15px !important",
  },
};

const BatchShelfInnerRow = ({ batch }: { batch: BatchData }) => {

  const [openEditModal, setOpenEditModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [reloadShelf, setReloadShelf] = useState();

  return (
    <>
      <TableRow
        sx={{
          borderLeft: `1px solid ${ColorPallet.borderColor}`,
          borderRight: `1px solid ${ColorPallet.borderColor}`,
        }}
      >
        <TableCell 
        sx={commonTableCellStyles}>
          {batch.Batch}
          </TableCell>
        <TableCell 
        sx={commonTableCellStyles}>
          {batch.MedicineName}
          </TableCell>
        <TableCell 
        sx={commonTableCellStyles}>
          {batch.RemainingQty}
          </TableCell>
        <TableCell 
        sx={commonTableCellStyles}>
          {batch.ProductionDate}
          </TableCell>
        <TableCell 
        sx={commonTableCellStyles}>
          {batch.SupplierName}
          </TableCell>
      </TableRow>

      {openEditModal && (
        <AddNewShelfModal
        handleClose={() => setOpenEditModal(false)} 
        isEdit 
        setReloadShelf={setReloadShelf}/>
      )}

      {openViewModal && (
        <ViewShelfBranchDetails handleClose={() => setOpenViewModal(false)} />
      )}
    </>
  );
};

export default BatchShelfInnerRow;
